import React from 'react'
import { UserCreatorRecruitmentLpTpl } from '../../../components/templates'
import { Meta } from '../../../Meta'

export const UserCreatorRecruitmentLp: React.FC = () => {
  return (
    <>
      <Meta title="クリエイター募集" description="累計クリエイター登録1,000人突破。写真や動画、ライブトークでファンとつながるクリエイターを募集しています。" />
      <UserCreatorRecruitmentLpTpl />
    </>
  )
}
